module.exports = __webpack_public_path__ + "img/38.e9378a88.jpg";